import { createSlice } from "@reduxjs/toolkit";

const initialHistoriesState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    entitiesPreview: null,
    historyForEdit: undefined,
    lastError: null,
};
export const callTypes = {
    list: "list",
    action: "action",
};

export const historySlice = createSlice({
    name: "History",
    initialState: initialHistoriesState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.listLoading = false;
            state.actionsLoading = false;
        },
    },
});
